<template>
    <div>
        <div v-if="sending">
            <loading />
        </div>
        <div v-else>
            <b-form>
                <label>Affectation</label>
                <b-form-select
                    v-model="form.assigned_to"
                    :options="collaboratorOptions"
                    size="sm"
                    class="mb-3"
                />

                <label>Date du rendez-vous</label>
                <b-input-group class="mb-2">
                    <b-form-input
                        id="current-date"
                        v-model="formatted_deadline_date"
                        type="text"
                        placeholder="Date à définir"
                        autocomplete="off"
                        size="sm"
                        disabled
                        class="bg-white"
                        style="height: 30px"
                    ></b-form-input>
                    <b-input-group-append>
                        <b-form-datepicker
                            v-model="form.deadline_date"
                            button-only
                            right
                            label-no-date-selected="Date à définir"
                            label-prev-year="Année précédente"
                            label-next-year="Année prochaine"
                            label-prev-month="Mois précédent"
                            label-next-month="Mois prochain"
                            label-current-month="Mois actuel"
                            label-help="Vous pouvez utiliser les flèches du clavier pour naviguer"
                            start-weekday="1"
                            aria-controls="current-date"
                            locale="fr"
                            @context="formatDeadlineDate"
                        >
                        </b-form-datepicker>
                    </b-input-group-append>
                </b-input-group>
                <div class="row mt-3 mb-3">
                    <div class="col-6">
                        <label>Heure du RDV</label>
                        <b-form-select
                            v-if="ready"
                            v-model="form.time"
                            size="sm"
                            style="
                                font-family: 'Syne Mono', monospace;
                                color: black;
                            "
                            :options="timeOptions"
                        />
                    </div>
                    <div class="col-6">
                        <label>Durée du RDV</label>
                        <b-form-select
                            v-if="ready"
                            v-model="form.duration"
                            size="sm"
                            style="
                                font-family: 'Syne Mono', monospace;
                                color: black;
                            "
                            :options="durationOptions"
                        />
                    </div>
                </div>
                <label>Lieu du rendez-vous</label>
                <b-form-textarea
                    v-model="form.appointment_location"
                    placeholder="Lieu à renseigner obligatoirement"
                    rows="3"
                    size="sm"
                ></b-form-textarea>
                <div class="mt-2">
                    <div v-if="formType === 'edit'" class="row">
                        <div class="col-6">
                            <b-button
                                variant="danger"
                                block
                                size="sm"
                                @click="showConfirmationModal"
                            >
                                <i class="fal fa-trash-alt fa-fw"></i
                                ><span class="pl-2">Supprimer</span>
                            </b-button>
                        </div>
                        <div class="col-6">
                            <b-button
                                variant="success"
                                block
                                size="sm"
                                @click="saveAppointment"
                            >
                                <i class="fal fa-save fa-fw"></i
                                ><span class="pl-2">Enregistrer</span>
                            </b-button>
                        </div>
                    </div>
                    <div v-else>
                        <b-button
                            variant="success"
                            block
                            size="sm"
                            :disabled="disableSubmit"
                            @click="saveAppointment"
                        >
                            <i class="fal fa-save fa-fw"></i
                            ><span class="pl-2">Enregistrer</span>
                        </b-button>
                    </div>
                </div>
            </b-form>
        </div>
    </div>
</template>

<script>
import timeOptions from '../../../common/data/timeOptions.json'
import durationOptions from '../../../common/data/durationOptions.json'
import DataUpdater from '../../../dashboard/mixins/DataUpdater.vue'

export default {
    name: 'AppointmentForm',

    mixins: [DataUpdater],

    props: {
        clientDeadline: {},
        client: {},
    },

    data() {
        return {
            form: {},
            formType: '',
            formatted_deadline_date: '',
            timeOptions,
            durationOptions,
            collaboratorOptions: [],
            ready: false,
            sending: false,
        }
    },

    computed: {
        disableSubmit() {
            return (
                !this.form.hasOwnProperty('deadline_date') ||
                !this.form.hasOwnProperty('appointment_location')
            )
        },
    },

    async created() {
        await this.getCollaborators()
        this.initForm()
        this.ready = true
    },

    methods: {
        async getCollaborators() {
            try {
                const response = await axios.get(
                    `/clients/${this.client.id}/appointmentOptions`
                )
                this.collaboratorOptions = response.data.data
            } catch (error) {
                console.log(error)
            }
        },

        initForm() {
            if (this.clientDeadline !== null) {
                this.formType = 'edit'
                this.form.assigned_to = this.clientDeadline.assigned_to
                this.form.deadline_date = this.clientDeadline.deadline_date
                this.form.time = this.clientDeadline.deadline_time
                this.form.duration = this.clientDeadline.duration
                this.form.appointment_location =
                    this.clientDeadline.appointment_location
            } else {
                this.form.client_id = this.client.id
                this.formType = 'create'
                this.form.assigned_to = this.collaboratorOptions[0].id
                this.form.duration = 1
                this.form.time = '09:00:00'
            }
        },

        async saveAppointment() {
            this.sending = true
            if (this.formType === 'edit') {
                try {
                    await axios.put(
                        `/clientDeadlines/appointment/${this.clientDeadline.id}`,
                        this.form
                    )
                    this.updateData()
                } catch (error) {
                    console.log(error)
                }
            } else {
                try {
                    await axios.post('/clientDeadlines/appointment', this.form)
                    this.updateData()
                } catch (error) {
                    console.log(error)
                }
            }
            this.sending = false
        },

        async deleteItem() {
            try {
                await axios.delete(
                    `/clientDeadlines/appointment/${this.clientDeadline.id}`
                )
                this.updateData()
            } catch (error) {
                console.log(error)
            }
        },

        showConfirmationModal() {
            this.$bvModal
                .msgBoxConfirm(
                    'Etes vous sûr·e de vouloir supprimer ce rendez-vous ?',
                    {
                        title: 'Confirmation',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Supprimer',
                        cancelTitle: 'Annuler',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true,
                    }
                )
                .then((value) => {
                    if (value) {
                        this.deleteItem()
                    }
                })
                .catch((err) => {
                    // An error occurred
                })
        },

        formatDeadlineDate(ctx) {
            this.formatted_deadline_date = ctx.selectedFormatted
        },
    },
}
</script>

<style scoped></style>
